import {
  MCC_CHART_SUMMARY_REQUEST,
  MCC_CHART_SUMMARY_REQUEST_SUCCESS,
  MCC_CHART_SUMMARY_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const mccChartSummaryReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MCC_CHART_SUMMARY_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MCC_CHART_SUMMARY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MCC_CHART_SUMMARY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default mccChartSummaryReducer;
